import { PERMISSIONS } from '@libs/core';

import type { MenuItem } from '@/types';

export const PAGE_ROUTE_TO_TITLE: Record<string, string> = {
    '/': 'Homepage',
    '/promo-offer': 'Promotion Offer Assignment',
    '/categories': 'Category Unassignment',
};

export const SIDEBAR_MENU_ITEMS: MenuItem[] = [
    {
        title: 'Homepage',
        path: '/',
        permission: 'all', // Everyone can see homepage
    },
    {
        title: 'Promotion Offer Assignment',
        path: '/promo-offer',
        permission: PERMISSIONS.PROMO_JOBS,
    },
    {
        title: 'Category Workflow',
        path: '/categories',
        permission: PERMISSIONS.CATEGORY_JOBS,
    },
    {
        title: 'Bulk Promo Generation',
        path: '/bulk-promo',
        permission: PERMISSIONS.BULK_PROMO,
    },
    {
        title: 'Shop Category Definitions',
        path: '/shop-category',
        permission: PERMISSIONS.ADMIN,
    },
];

export const USER_MENU_ITEMS: MenuItem[] = [
    {
        title: 'Profile',
        path: '/profile',
        permission: 'all', // Everyone can see profile
    },
];
